/**
 * Zone `auth` de l'arbre de routes : `/login`, `/signup`, `/email-sent`…
 *
 * @remarks
 * Isolée de `createRouter` pour être testée sans le registry de features.
 *
 * L'`errorElement` est posé sur un nœud **enfant** de l'`AuthLayout`, pas sur
 * lui : le fallback s'affiche ainsi dans le cadre de marque (fond, thème sombre)
 * au lieu de le remplacer. Il arrête toute erreur des vues d'auth avant le
 * `RootErrorBoundary` (SAAS-984).
 */

import type { RouteObject } from 'react-router-dom';
import { AuthLayout } from '@/app/layout/AuthLayout';
import { AuthErrorFallback } from './AuthErrorFallback';

export function buildAuthZone(routes: RouteObject[]): RouteObject {
  return {
    element: <AuthLayout />,
    children: [{ errorElement: <AuthErrorFallback />, children: routes }],
  };
}
